import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Concept from "@/components/Concept";
import Manifesto from "@/components/Manifesto";
import Process from "@/components/Process";
import Gallery from "@/components/Gallery";
import RequestForm from "@/components/RequestForm";
import Payment from "@/components/Payment";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollLight from "@/components/ScrollLight";
import Preloader, { useIntro } from "@/components/Preloader";
import { Veil } from "@/components/Reveal";

export default function Home() {
  const ready = useIntro();
  return (
    <main className="bg-obsidian text-ivory">
      <Preloader done={ready} />
      <ScrollLight />
      <Navbar />
      <Hero ready={ready} />
      <Marquee />
      <Concept />
      <Manifesto />
      <Process />
      <Gallery />
      <RequestForm />
      <Veil />
      <Payment />
      <Veil />
      <Faq />
      <Veil />
      <Contact />
      <Footer />
    </main>
  );
}
